import React, { useState, useEffect, useRef } from "react";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import {
  FormControlLabel,
  Switch,
  Grid,
  Typography,
  LinearProgress
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import green from "@material-ui/core/colors/green";
import grey from "@material-ui/core/colors/grey";

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(2)
  },

  video: {
    width: "100%"
  },

  volumeBar: {
    width: "100%",
    height: "6px",
    backgroundColor: grey[500]
  },

  volumeValue: {
    width: "0%",
    height: "6px",
    backgroundColor: green["A400"]
  }
}));

export default function MediaSelect({ open, close, join }) {
  const classes = useStyles();

  const [hasMicrophone, setHasMicrophone] = useState(false);
  const [hasWebcam, setHasWebcam] = useState(false);
  const [micVolume, setMicVolume] = useState(0);

  const videoRef = useRef({});
  const audioContext = useRef({});

  //check if we have permission for mic and or web cam already

  //check if user has mic / web cam

  //ask for permission for whichever they have

  //display
  useEffect(() => {
    if (open) {
      audioContext.current = new AudioContext();

      navigator.getMedia =
        navigator.getUserMedia || // use the proper vendor prefix
        navigator.webkitGetUserMedia ||
        navigator.mozGetUserMedia ||
        navigator.msGetUserMedia;

      navigator.getMedia(
        { video: true, audio: true },
        function(stream) {
          //got mic and webcam access
          videoRef.current.srcObject = stream;
          videoRef.current.volume = 0;
          setHasMicrophone(true);
          setHasWebcam(true);
          onMicrophoneGranted(stream);
        },
        function() {
          //user doesn't have webcam or denied access, ask for mic

          navigator.getMedia(
            { audio: true },
            function() {
              //got mic access
              setHasMicrophone(true);
            },
            function() {
              //no mic access
            }
          );
        }
      );
      return () => {
        audioContext.current.close();
      };
    }
  }, [open]);

  function toggleMic() {
    setHasMicrophone(!hasMicrophone);
  }

  function toggleCam() {
    setHasWebcam(!hasWebcam);
  }

  function startMedia() {
    close();
    join(hasMicrophone, hasWebcam);
  }

  function onMicrophoneGranted(stream) {
    // Create an AudioNode from the stream.

    let analyser = audioContext.current.createAnalyser();
    let microphone = audioContext.current.createMediaStreamSource(stream);
    let javascriptNode = audioContext.current.createScriptProcessor(2048, 1, 1);

    analyser.smoothingTimeConstant = 0.8;
    analyser.fftSize = 1024;

    microphone.connect(analyser);
    analyser.connect(javascriptNode);
    javascriptNode.connect(audioContext.current.destination);
    javascriptNode.onaudioprocess = function() {
      var array = new Uint8Array(analyser.frequencyBinCount);
      analyser.getByteFrequencyData(array);
      var values = 0;

      var length = array.length;
      for (var i = 0; i < length; i++) {
        values += array[i];
      }

      var average = values / length;

      //console.log(Math.round(average));
      //setMicVolume(Math.round(average));
      document.getElementById("volumeValue").style.width =
        Math.round(average) + "%";
    };
  }

  return (
    <div>
      <Dialog
        open={open}
        aria-labelledby="form-dialog-title"
        fullWidth
        onClose={close}
      >
        <DialogTitle id="form-dialog-title" disableTypography>
          <Typography align="center" variant="h6">
            Join Conference
          </Typography>
        </DialogTitle>
        <DialogContent>
          <Grid
            container
            direction="row"
            justify="space-between"
            alignContent="center"
            alignItems="center"
            spacing={2}
          >
            <Grid item xs={12} sm={6}>
              <Grid
                container
                direction="column"
                alignItems="center"
                spacing={1}
              >
                <Grid item>
                  <video autoPlay ref={videoRef} className={classes.video} />
                </Grid>
                <Grid item>
                  <FormControlLabel
                    control={
                      <Switch
                        color="primary"
                        onChange={toggleCam}
                        checked={hasWebcam}
                      />
                    }
                    label="Webcam"
                  />
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12} sm={6}>
              <Grid container alignItems="center" justify="center" spacing={1}>
                <Grid item xs={12}>
                  <div id="volumeBar" className={classes.volumeBar}>
                    <div id="volumeValue" className={classes.volumeValue} />
                  </div>
                </Grid>
                <Grid item>
                  <FormControlLabel
                    control={
                      <Switch
                        color="primary"
                        onChange={toggleMic}
                        checked={hasMicrophone}
                      />
                    }
                    label="Microphone"
                  />
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button color="primary" onClick={close}>
            Cancel
          </Button>
          <Button color="primary" onClick={startMedia}>
            OK
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
